import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../login/auth";
import { Link } from "react-router-dom";
import keys from "../../config/keys";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        <header>
          <nav className="navbar navbar-expand navbar-dark flex-column flex-md-row bg-dark">
            <ul className="navbar-nav bd-navbar-nav flex-row">
              {this.props.auth.userId && (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Account/StudentAccount/Dashboard"
                  >
                    <i className="fa fa-tachometer" aria-hidden="true" />
                    Dashboard
                  </Link>
                </li>
              )}
              {this.props.auth.userId && (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Account/StudentAccount/UserProfile"
                  >
                    <i className="fa fa-user-circle" aria-hidden="true" />
                    User Profile
                  </Link>
                </li>
              )}
              {!this.props.auth.userId && (
                <li className="nav-item nav-logo">
                  <Link to="/" className="navbar-brand">
                    <img
                      src={keys.websiteSetting.Logo}
                      height="55"
                      className="d-inline-block align-top"
                      alt="logo"
                    />
                  </Link>
                </li>
              )}
              {this.props.auth.userId && (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Account/StudentAccount/AdmissionForm/0"
                  >
                    <i className="fa fa-wpforms" aria-hidden="true" />
                    AdmissionForm
                  </Link>
                </li>
              )}
            </ul>

            {!this.props.auth.userId && (
              <ul className="navbar-nav flex-row ml-md-auto  d-xs-flex">
                <li className="onlineAdmissionText">Admission (2019-20)</li>
              </ul>
            )}

            <ul className="navbar-nav flex-row ml-md-auto  d-xs-flex">
              {this.props.auth.userId && (
                <li className="nav-item">
                  <span
                    className="nav-link"
                    onClick={() => this.props.logout()}
                  >
                    <i className="fa fa-lock" aria-hidden="true" />
                    Logout
                  </span>
                </li>
              )}
              {!this.props.auth.userId && (
                <li className="nav-item">
                  <Link to="/Login" className="nav-link dash-link">
                    <i className="fa fa-user-circle" aria-hidden="true" />
                    {/* <i className="fa fa-sign-in" aria-hidden="true" /> */}
                    Login
                  </Link>
                </li>
              )}

              {keys.websiteSetting.signUpContent !== "nvu" &&
                !this.props.auth.userId && (
                  <li className="nav-item">
                    <Link to="/SignUp" className="nav-link dash-link">
                      <i className="fa fa-sign-in" aria-hidden="true" />
                      SignUp
                    </Link>
                  </li>
                )}
            </ul>
          </nav>
        </header>
      </div>
    );
  }
}
function mapStateToProps({ auth }) {
  return { auth };
}
export default connect(
  mapStateToProps,
  actions
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js